import React, { useContext, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import MonitoringContainer from "./MonitoringContainer";
import { APIContext } from "../Contexts/APIContext"

export default function CallContainer() {
    const { checkRoles, get } = useContext(APIContext);
    const [searchParams] = useSearchParams();
    const callId = searchParams.get('callId');
    const [systemPk, setSystemPk] = useState<string | null>(null);

    // This component is called outside of the Search route so roles need to be set for the API context
    useEffect(() => {
        checkRoles();
        get('Info', `GetSystemPkFromSystemId?systemId=${callId}`, data => setSystemPk(data))
    }, [callId])

    return (
        <>
            {systemPk !== null && (
                <MonitoringContainer
                    id={systemPk}
                    setId={() => { }}
                    close={() => { }}
                    mainView
                    showBackButton={false}
                />
            )}
        </>
    )
}